import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CommonPopupComponent } from '@public/common-popup/common-popup.component';
import { DialogControlService } from '@shared/services/dialog-control.service';

@Component({
  selector: 'app-landing-v1',
  templateUrl: './landing-v1.component.html',
  styleUrls: ['./landing-v1.component.scss']
})
export class LandingV1Component {
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  isClicked: boolean = false;
  presentComponent: number = 0

  constructor(
    private readonly dialogControlService: DialogControlService,
  ) { }

  clickMenu(event: Event) {
    event.stopPropagation();
    this.isClicked = !this.isClicked
  }

  openPopup() {
    this.dialogControlService.openDialog(CommonPopupComponent, {
      styleClass: 'common-login-popup',
    });
  }

  @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  }
}